module.exports = __webpack_public_path__ + "img/accept_icon.05b6edaf.png";